import NiceModal from "@ebay/nice-modal-react";
import {toast} from "sonner";
import AreYouSureDialog from "@bounce/shared/consumer/bounce-ui/components/Dialogs/AreYouSureDialog";
import {useDeleteTrigger} from "../../apis/requests/triggers/deleteTrigger";

export const useConfirmDeleteTrigger = () => {
  const {mutate: deleteTrigger, isPending: isDeleting} = useDeleteTrigger();

  const confirmDelete = (trigger: {id: number; name: string}, onDeleted?: () => void) =>
    NiceModal.show(AreYouSureDialog, {
      onConfirm: () =>
        deleteTrigger(
          {id: trigger.id},
          {
            onSuccess: () => {
              toast.success(`Trigger "${trigger.name}" deleted`);
              onDeleted?.();
            },
          }
        ),
      headerTextId: "Delete trigger?",
      contentTextId: `Are you sure you want to delete "${trigger.name}"? Messages it scheduled that haven't gone out yet will not be sent.`,
      confirmTextId: "Delete",
    });

  return {confirmDelete, isDeleting};
};
